import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "productExistingCustomerFields",
    "newCustomerFields",
    "deliveryAddressFields",
    "customerMode",
    "additionalAddress",
    "additionalDeliveryAddress"
  ];
  
  static value = {
    formObject: Object,
    identificationDocumentUrl: String,
    contractType: String,
    monthlyAmount: Number
  }

  onCustomerModeChanged() {
    this.toggleCustomerMode();
    if (!this.productExistingCustomerFieldsTarget.classList.contains("d-none")) {
      let element = document.getElementById("select2-np_contract_customer_id-container");
      let element_name = "select2-np_contract_customer_id-container";
      let formData = "#new_np_contract";
      if (window.location.href.includes("/silver_calculations")) {
        element = document.getElementById("select2-nps_contract_customer_id-container");
        formData = "#new_nps_contract";
        element_name = "select2-nps_contract_customer_id-container";
      }
      const submit = document.getElementById("for_valid_customers");
      const info_valid_customer = document.getElementById("flash_valid");
      const observer = new MutationObserver(() => {
        const productCustomerNumber = element.textContent.trim().split(/\s+/)[0].slice(1);
        this.searchDocument(productCustomerNumber, submit, info_valid_customer, formData);
        $.ajax({
          url: `/contracts/identity_data_form.json?customer_id_for_searching=${productCustomerNumber}`,
          type: "POST",
          processData: false,
          contentType: false,
          data: new FormData(document.querySelector(formData)),
          dataType: "text",
          success: (r) => {
            const check_customer = r.split(",")[1];
            if (check_customer === "false" || check_customer === "userFalse") {
              submit.classList.add("d-none");
              info_valid_customer.classList.remove("d-none");
            } else {
              submit.classList.remove("d-none");
              info_valid_customer.classList.add("d-none");
            }
          }
        });
      });
      observer.observe(element, { childList: true, subtree: true });
    }
  }

  showFiledFirmName() {
    $("#select2-np_contract_customer_attributes_user_attributes_appeal-container").on("DOMSubtreeModified",function(){
      const span = document.getElementById("select2-np_contract_customer_attributes_user_attributes_appeal-container");
      const firma = document.getElementById("company_name_firma_np");
      if(span.innerText === "Firma") {
        firma.classList.remove("d-none");
      } else {
        firma.classList.add("d-none");
      }
    });
    $("#select2-nps_contract_customer_attributes_user_attributes_appeal-container").on("DOMSubtreeModified",function(){
      const span = document.getElementById("select2-nps_contract_customer_attributes_user_attributes_appeal-container");
      const firma = document.getElementById("company_name_firma_np");
      if(span.innerText === "Firma") {
        firma.classList.remove("d-none");
      } else {
        firma.classList.add("d-none");
      }
    });
  }

  searchDocument(customerNumber, submit, info_valid_customer, formData) {
    $.ajax({
      url: `/contracts/identity_data_form.json?customer_id_for_searching=${customerNumber}`,
      type: "POST",
      processData: false,
      contentType: false,
      data: new FormData(document.querySelector(formData)),
      dataType: "text",
      success: (r) => {
        const check_customer = r.split(",")[1];
        if (check_customer === "false" || check_customer === "userFalse") {
          submit.classList.add("d-none");
          info_valid_customer.classList.remove("d-none");
        } else {
          submit.classList.remove("d-none");
          info_valid_customer.classList.add("d-none");
        }
      }
    });
  }

  onDifferentDeliveryAddressChanged(e) {
    this.toggleDifferentDeliveryAddressFields(e.target.checked);
  }

  onShowAdditionalAddressClick(e) {
    e.preventDefault();
    e.target.remove();
    this.showAdditinalAddress();
  }

  onShowAdditionalDeliveryAddressClick(e) {
    e.preventDefault();
    e.target.remove();
    this.showAdditinalDeliveryAddress();
  }

  onSubmit() {
    if (this.customerMode === "existing") {
      this.newCustomerFieldsTarget.remove();
    }
  }

  toggleCustomerMode() {
    if (this.customerMode === "existing") {
      this.productExistingCustomerFieldsTarget.classList.remove("d-none");
      this.newCustomerFieldsTarget.classList.add("d-none");
    } else {
      this.productExistingCustomerFieldsTarget.classList.add("d-none");
      this.newCustomerFieldsTarget.classList.remove("d-none");
    }
  }

  toggleDifferentDeliveryAddressFields(show) {
    this.deliveryAddressFieldsTarget.classList.toggle("d-none", !show);
  }

  showAdditinalAddress() {
    this.additionalAddressTarget.classList.remove("d-none");
  }

  showAdditinalDeliveryAddress() {
    this.additionalDeliveryAddressTarget.classList.remove("d-none");
  }

  get customerMode() {
    const checkedRadio = this.customerModeTargets.find(radio => radio.checked);
    return checkedRadio ? checkedRadio.value : null;
  }
}
